import { GalleryMediaContainerProps, GalleryMediaSearchResponse } from "./GalleryMediaContainerProps";
import { NoResults } from "@kaltura/mediaspace-shared-search";
import { MediaGrid } from "@kaltura/mediaspace-shared-media-grid";
import MediaList from "./list/MediaList";
import { Pagination } from "@kaltura/ds-react-components";

interface GalleryMediaProps extends GalleryMediaContainerProps {
    fetchData: () => GalleryMediaSearchResponse;
    isSearch: boolean;
    page: number;
    onPageChange: (page: number) => void;
}

export const GalleryMedia = (props: GalleryMediaProps) => {
    const {
        fetchData,
        isSearch,
        page,
        onPageChange,
        pageSize,
        isGridView,
        content,
        categoryId,
        showSpeakersForContentSectionEntries = false,
        ...rest
    } = props;

    const { entries, totalCount } = fetchData();
    const pagesCount = Math.ceil(totalCount / pageSize);

    if (totalCount === 0) {
        return <NoResults screenMode={isSearch ? "nomatches" : "nopublic"} />;
    }

    return (
        <>
            {isGridView && (
                <MediaGrid
                    content={entries}
                    categoryId={categoryId}
                    showPagination={false}
                    {...rest}
                    // `rest` might include `analyticsValue` prop - override it
                    analyticsValue={"Media thumbnail link"}
                />
            )}

            {!isGridView && (
                <MediaList
                    content={entries}
                    categoryId={categoryId}
                    headingLevel={"h2"}
                    additionalParams={{
                        showSpeakersForContentTabEntries: showSpeakersForContentSectionEntries,
                        analyticsValue: "Media",
                    }}
                    {...rest}
                />
            )}

            {pagesCount > 1 && (
                <Pagination page={page} count={pagesCount} onChange={(_ev, page) => onPageChange(page)} />
            )}
        </>
    );
};
